import { LogIn } from 'lucide-react';
import type { TenantBranding } from '../types';

interface LoginPageProps {
  onLogin: () => void;
  branding?: TenantBranding;
}

export default function LoginPage({ onLogin, branding }: LoginPageProps) {
  // Logo priority: per-tenant branding > Delldata default. The Delldata
  // logo lives in /public so Vite serves it at the root path.
  const logoSrc = branding?.logo_url || '/delldata_logo.png';
  const companyName = branding?.company_name || 'Delldata Dashboard';

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 flex items-center justify-center p-4">
      {/* Background decorations */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-blue-500/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-emerald-500/5 rounded-full blur-3xl" />
      </div>

      <div className="relative w-full max-w-md">
        <div className="bg-slate-800/50 backdrop-blur-xl rounded-3xl border border-slate-700/50 p-8 shadow-2xl">
          {/* Logo */}
          <div className="text-center mb-8">
            <div className="w-20 h-20 mx-auto rounded-2xl bg-white/5 ring-1 ring-slate-700/40 flex items-center justify-center mb-4 p-3">
              <img
                src={logoSrc}
                alt={companyName}
                className="w-full h-full object-contain"
              />
            </div>
            <h1 className="text-2xl font-bold text-white mb-2">
              {companyName}
            </h1>
            <p className="text-slate-400">Sales Dashboard</p>
          </div>

          {/* Login Button */}
          <button
            onClick={onLogin}
            className="w-full flex items-center justify-center gap-3 px-6 py-4 rounded-xl bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400 text-white font-semibold transition-all duration-200 shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40"
          >
            <LogIn size={20} />
            Sign In
          </button>

          {/* Co-branding: Powered by GeniReports */}
          <div className="mt-6 flex items-center justify-center gap-2">
            <span className="text-[11px] text-slate-500 uppercase tracking-wider">Powered by</span>
            <img
              src="/GeniReport_Logo_Round.png"
              alt="GeniReports"
              className="h-5 w-5 object-contain opacity-80"
            />
            <span className="text-xs text-slate-400 font-medium">GeniReports</span>
          </div>

          {/* Footer */}
          <p className="text-center text-slate-500 text-xs mt-3">
            Secure login powered by Auth0
          </p>
        </div>
      </div>
    </div>
  );
}
